import { FC, ReactNode } from 'react';
import { Text } from '../components/Text';

interface ISlideHeadingProps {
    title: string;
    description: ReactNode;
}

export const SlideHeading: FC<ISlideHeadingProps> = ({ title, description }) => {
    return (
        <div style={{textAlign: 'center'}}>
            <div style={{fontSize: 24, fontWeight: 'bold'}}>{title}</div>
            <div style={{padding: '20px 0 0'}}>
                <Text type="detail">{description}</Text>
            </div>
        </div>
    );
};
